import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

const GiftCardCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-6">
      <div className="bg-white rounded-2xl shadow-lg p-10 max-w-md w-full text-center">
        <XCircle className="mx-auto text-red-500 mb-4" size={64} />
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
         Payment Cancelled
        </h1>
        <p className="text-gray-600 mb-6">
          Something interrupted the process, and your order couldn't be completed. 
          Rest assured, your account remains unchanged.
        </p>
        <button
          onClick={() => navigate("/gift-cards")}
          className="w-full bg-[#00ADEF] text-white py-3 rounded-lg font-semibold hover:bg-[#0096d3] transition duration-200"
        >
          Browse Gift Cards
        </button>
      </div>
    </div>
  );
};

export default GiftCardCancel;
